// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"Blockquote-module--blockquote--3OVwX"};